<ion-header class="ion-no-border header-translucent header-collapse-none">
  <ion-toolbar class="toolbar-title-default">
    <ion-buttons slot="start" class="buttons-first-slot brand">
      <ion-button
        *ngIf="!isMobile"
        fill="clear"
        class="nav-btn"
        (click)="toggleMenu()"
      >
        <ion-icon name="menu-outline" size="large" color="secondary"></ion-icon>
      </ion-button>
      <ion-menu-button
        *ngIf="isMobile"
        style="color: #00b5d6"
      ></ion-menu-button>
      <img
        src="/assets/img/logo-navy.svg"
        alt="Fleetdynamics"
        class="brand-logo brand-logo--on-light"
      />
      <img
        src="/assets/img/logo.svg"
        alt="Fleetdynamics"
        class="brand-logo brand-logo--on-dark"
      />
    </ion-buttons>
    <ion-title class="title title-default">{{ title }}</ion-title>
  </ion-toolbar>
</ion-header>
